var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "SearchWithFilter",
    {
      attrs: {
        query: _vm.query,
      },
      on: {
        search: _vm.onSearch,
      },
      scopedSlots: _vm._u([
        {
          key: "filters",
          fn: function fn() {
            return [
              _vm.hasOrientationFilter
                ? _c(
                    "ActiveFilter",
                    {
                      attrs: {
                        name: _vm.orientations[_vm.orientation].text,
                      },
                      on: {
                        remove: function remove($event) {
                          return _vm.onRemoveOrientationFilter()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.orientations[_vm.orientation].text) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.selectedColors, function (color) {
                return _c(
                  "ActiveFilter",
                  {
                    key: color.hex,
                    attrs: {
                      name: _vm.$gettextInterpolate(
                        _vm.$gettext("Farbe %{color}"),
                        {
                          color: color.name,
                        }
                      ),
                    },
                    on: {
                      remove: function remove($event) {
                        return _vm.onRemoveColorFilter(color)
                      },
                    },
                  },
                  [
                    _c("label", [
                      _c("b", {
                        staticClass: "stock-images-color-patch",
                        style: "background-color: ".concat(color.hex),
                      }),
                    ]),
                  ]
                )
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stock-images-search-filter-panel",
        },
        [
          _c("div", [
            _c("label", [
              _c("div", [_vm._v(_vm._s(_vm.$gettext("Seitenausrichtung")))]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.orientation,
                      expression: "orientation",
                    },
                  ],
                  on: {
                    change: function change($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.orientation = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(Object.entries(_vm.orientations), function (_ref) {
                  var key = _ref[0],
                    value = _ref[1]
                  return _c(
                    "option",
                    {
                      key: "orientation-option-".concat(key),
                      domProps: {
                        value: key,
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(value.text) +
                          "\n                    "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", [_vm._v(_vm._s(_vm.$gettext("Farbfilter")))]),
              _vm._v(" "),
              _c("studip-select", {
                attrs: {
                  multiple: "",
                  options: _vm.selectableColors,
                  label: "name",
                },
                scopedSlots: _vm._u([
                  {
                    key: "open-indicator",
                    fn: function fn() {
                      return [
                        _c(
                          "span",
                          [
                            _c("studip-icon", {
                              attrs: {
                                shape: "arr_1down",
                                size: 10,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "option",
                    fn: function fn(option) {
                      return [
                        _c("span", {
                          staticClass: "vs__option-color",
                          style: {
                            "background-color": option.hex,
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(option.name))]),
                      ]
                    },
                  },
                  {
                    key: "selected-option-container",
                    fn: function fn() {
                      return [_vm._v(_vm._s(" "))]
                    },
                    proxy: true,
                  },
                  {
                    key: "no-options",
                    fn: function fn() {
                      return [
                        _vm._v(
                          _vm._s(_vm.$gettext("Keine Auswahlmöglichkeiten"))
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.selectedColors,
                  callback: function callback($$v) {
                    _vm.selectedColors = $$v
                  },
                  expression: "selectedColors",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }